const PLATFORM_TIME_ZONE = "America/New_York";
export {
  PLATFORM_TIME_ZONE
};
//# sourceMappingURL=timeZone.js.map
